<template>
<div class="page-wrapper about-page credits-page">
    <div class="about-background"></div>
    <div class="nav-info">
        <NavInfo />
    </div>
    <main class="about-info" id="topPage">
        <div class="credits">
            <h1 class="wcrc">Credits</h1>
            <ul>
                <li>
                    <span>Creative Director</span> <span>Rebecca Mordan</span>
                </li>
                <li>
                    <span>Digital Marketing</span> <span>Becky John / 92 Minutes</span>
                </li>
                <li>
                    <span>Production Assistant</span> <span>Vanessa Pini</span>
                </li>
                <li>
                    <span>Company Manager</span> <span>Adrian Walker</span>
                </li>
                <li>
                    <span>Producer</span> <span>Sharon Foster</span>
                </li>
                <li class="br">
                    <span>Design & Development</span> <span>Animorph Co-operative</span>
                </li>
                <li class="br">
                    <span>Audio Editing</span> <span>Alice Robinson <br> Danny Searle</span>
                </li>
                <li class="br">
                    <span>PR Support</span> <span>JKC</span>
                </li>
                <li class="br">
                    <span>Greenham Women Advisors</span> <span>Carolyn Francis <br> Penny Gulliver <br> Mica May <br> Maggie Parks <br> Jill Raymond aka Ray <br> Sue Say</span>
                </li>
                <li class="br">
                    <span>Musical Permissions</span> <span>Frankie Armstrong <br> Carolyn Francis <br> Holly Near <br> Peggy Seeger <br> Armorel Weston <br> Priscilla Andersohn</span>
                </li>
                <li class="br">
                    <span>Photographers</span> <span>Bridget Boudewijn <br> Sandie Hicks</span>
                </li>
                <li>
                    <span>Funding</span> <span>Arts Council National Lottery Project Grants</span>
                </li>
            </ul>
        </div>
        <div class="biographies">
            <h2>Biographies</h2>
            <ul class="credit-bios">
                <li v-for="(credit, index) in credits" :key="index">
                    <details>
                        <summary class="credit-name">
                            <img :src="credit.img" :alt="credit.name">
                            <p>{{credit.name}}</p>
                        </summary>
                        <div class="credit-bio">
                            <p>{{credit.bio}}</p>
                            <span class="credit-category">{{ credit.category }}</span>
                            <a v-if="checkIfEmpty( credit.url )" :href="credit.url">Website</a>
                        </div>
                    </details>
                </li>
            </ul>
        </div>
    </main>
</div>
</template>

<script>
import NavInfo from "../components/NavInfo";
import CreditsList from '../mixins/credits-list'

export default {
    name: "Credits",
    mixins: [
        CreditsList
    ],
    components: {
        NavInfo
    },
    methods: {
        checkIfEmpty(passedString) {
            return passedString.length > 1
        }
    },
  mounted() {
    document.getElementById("topPage").scrollIntoView();
  }
}
</script>

<style scoped>
.credits {
    padding-bottom: 1em;
}

.credits ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
}

.credits ul li {
    display: flex;

}

.credits ul li span {
    width: 50%;
}

.br {
    padding-bottom: 1em;
}

ul.credit-bios {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0;
    padding: 0;
}

ul.credit-bios li {
    width: 100%;
    list-style: none;
    padding-bottom: 1em;
    /* font-size: .75em; */
}

.credit-bio {
    padding-bottom: 1.25em;
}

.credit-bio p {
    margin-top: 0;
}

.credit-category {
    font-size: .7em;
    padding: .07em .5em;
    border-radius: .25em;
    border: 1px solid var(--darkest);
    margin-right: 1em;
}

.credit-name {
    display: flex;
    align-items: center;
    outline: 0;
    padding-bottom: .5em;
}

.credit-name:hover {
    color: var(--dark);
}

.credit-name img {
    display: inline;
    background-color: var(--dark);
    width: 100px;
    height: 100px;
    border-radius: .25em;
}

.credit-name p {
    padding-left: 1em;
    line-height: 1.1;
    font-size: 1.5em;
}
</style>
